import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoutes = () => {
    const uclToken = localStorage.getItem('uclToken');
    return uclToken ? <Outlet /> : <Navigate to="/login" />;
}

export default PrivateRoutes;
